import { render, staticRenderFns } from "./PriceBandList.vue?vue&type=template&id=e03c4586&scoped=true&"
import script from "./PriceBandList.vue?vue&type=script&lang=js&"
export * from "./PriceBandList.vue?vue&type=script&lang=js&"
import style0 from "./PriceBandList.vue?vue&type=style&index=0&id=e03c4586&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e03c4586",
  null
  
)

export default component.exports